const TotalRevenue = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        width="55.7828"
        height="55.7828"
        rx="27.8914"
        fill="#3980F2"
      />
      <mask
        id="mask0_98_5041"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="15"
        y="16"
        width="25"
        height="25"
      >
        <rect x="15.4668" y="16.0062" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_98_5041)">
        <path
          d="M29.1287 28.483C28.5038 28.483 27.9784 28.2701 27.5525 27.8442C27.1264 27.4181 26.9134 26.8926 26.9134 26.2677C26.9134 25.6429 27.1264 25.1175 27.5525 24.6914C27.9784 24.2654 28.5038 24.0523 29.1287 24.0523C29.7537 24.0523 30.2791 24.2654 30.705 24.6914C31.1311 25.1175 31.3441 25.6429 31.3441 26.2677C31.3441 26.8926 31.1311 27.4181 30.705 27.8442C30.2791 28.2701 29.7537 28.483 29.1287 28.483ZM22.2697 32.0193C21.7775 32.0193 21.3563 31.844 21.0059 31.4934C20.6555 31.143 20.4803 30.7218 20.4803 30.2298V22.3058C20.4803 21.8136 20.6555 21.3923 21.0059 21.0419C21.3563 20.6915 21.7775 20.5163 22.2697 20.5163H35.9878C36.4799 20.5163 36.9012 20.6915 37.2516 21.0419C37.602 21.3923 37.7772 21.8136 37.7772 22.3058V30.2298C37.7772 30.7218 37.602 31.143 37.2516 31.4934C36.9012 31.844 36.4799 32.0193 35.9878 32.0193H22.2697ZM23.3774 30.9116H34.8801C34.8801 30.4159 35.0553 29.9937 35.4057 29.645C35.7561 29.2964 36.1774 29.1222 36.6695 29.1222V23.4135C36.1739 23.4135 35.7517 23.2383 35.4032 22.8879C35.0545 22.5373 34.8801 22.116 34.8801 21.624H23.3774C23.3774 22.1197 23.2022 22.5418 22.8518 22.8904C22.5014 23.2391 22.0801 23.4135 21.5879 23.4135V29.1222C22.0836 29.1222 22.5057 29.2974 22.8543 29.6478C23.203 29.9982 23.3774 30.4194 23.3774 30.9116ZM34.4968 35.3423H18.9467C18.4545 35.3423 18.0332 35.167 17.6828 34.8165C17.3324 34.4661 17.1572 34.0449 17.1572 33.5529V23.7967H18.2649V33.5529C18.2649 33.7233 18.3359 33.8795 18.4779 34.0214C18.62 34.1636 18.7763 34.2347 18.9467 34.2347H34.4968V35.3423ZM22.2697 30.9116H21.5879V21.624H22.2697C22.0851 21.624 21.9253 21.6915 21.7904 21.8264C21.6554 21.9614 21.5879 22.1212 21.5879 22.3058V30.2298C21.5879 30.4145 21.6554 30.5742 21.7904 30.7092C21.9253 30.8441 22.0851 30.9116 22.2697 30.9116Z"
          fill="#3980F2"
        />
      </g>
    </svg>
  );
};

export default TotalRevenue;
